import { observable, action, toJS } from "mobx";
import { Render3dService } from "modules/render3D/Render3dService";
import { WBSStore } from "modules/WBS/WBSStore";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { IsolateArray } from "modules/render3D/models/IsolateArray";
import * as _ from "lodash";
import { ERightMenuTab } from "common/enums";

class Store {
  @observable modelIdCollection: Array<object> = [];
  @observable libraries: Array<object> = [];
  elements3d: Array<number> = [];
  types3d: Array<number> = [];
  itemsList: any = [];
  groups: any = [];
  @observable observableGroups: any = [];
  types: any = {};
  @observable observableTypes: any = {};
  @observable xeokitViewer: any = null;
  @observable cubeViewer: any = null;
  model: any = null;
  xktLoader: any = null;
  @observable sectionPlanesPlugin: any = null;
  @observable distanceMeasurementsPlugin: any = null;
  @observable mathSectionPlanesPlugin: any = null;
  containerElements: any = null;
  colorSquareSelected: any = null;
  @observable clickEvent: boolean = false;
  @observable action: string = "info";
  @observable agroup: string = "element";
  @observable apply: string = "selected";
  @observable filter: string = "type";
  @observable color: object = { r: 255, g: 255, b: 255, a: 1 };
  modelStyles: Array<object> = [];
  selectedElement: any = false;
  @observable observableSelectedElement: any = false;
  featuredElement: any = false;
  @observable observableFeaturedElement: any = false;
  workerCallback: any = false;
  workerResting: any = true;
  @observable isolateArray: Array<IsolateArray> = [];
  needIsolateArray: boolean = false;
  @observable modoPanOnOff: boolean = false;
  esmaecerItem: boolean = false;
  visibilityItem: boolean = false;
  invisibilityItem: boolean = false;
  @observable reloadViewer: boolean = true;
  @observable loadingViewer: boolean = false;
  @observable toolbarLoading: boolean = false;
  ifcRefIdsLoaded: any = [];
  typesNavigation: any = [];
  itemsViewTmp: any = new Array<object>();
  @observable itemsView: any = new Array<object>();
  @observable itemsViewSelected: Array<IsolateArray> =
    new Array<IsolateArray>();
  @observable itemSelectedCached: any = new Array();
  @observable itemUnVisibilityList: Array<IsolateArray> =
    new Array<IsolateArray>();
  @observable itemUnVisibilityTypeList: any = new Array();
  itemEsmaecerTypeList: Array<IsolateArray> = new Array<IsolateArray>();
  @observable RenderViewActive = false;
  @observable fileName: any;
  @observable propertyRendered: any = [];
  @observable toggleClip: boolean = false;
  @observable isSectionPlanes: boolean = false;
  @observable isDistanceMeasurements: boolean = false;
  sectionPlaneId: string = "";
  @observable clipPercent: number = 100;
  @observable entitiesXrayed: any = [];
  @observable entitiesVisible: any = [];
  @observable metaModelIds: any = [];
  @observable metaModel: any = null;
  @observable selectedSimilarElements: any = [];

  // PRUBK-423 - Variáveis auxiliares para controlar estado de loading do viewer para carregamentos de IFCs federados
  @observable viewerStarted: boolean = false;
  viewerLoadCounter: number = 0;
  navigationLoaded: boolean = false;

  isReverseIsolate: boolean = false;
  reverseLabelArray: any = new Array<number>();

  @observable browserTree: boolean = false;

  @observable visibilityElement3D: any = [];

  resetViewer() {
    this.modelIdCollection = [];
    this.libraries = [];
    this.elements3d = [];
    this.types3d = [];
    this.itemsList = [];
    this.groups = [];
    this.observableGroups = [];
    this.xeokitViewer = null;

    if (this.cubeViewer && this.cubeViewer != null) {
      try {
        this.cubeViewer.destroy();
      } catch (e) {}
    }

    if (this.sectionPlanesPlugin != null) {
      this.sectionPlanesPlugin.clear();
      this.sectionPlanesPlugin.destroy();
    }

    this.containerElements = null;
    this.colorSquareSelected = null;
    this.clickEvent = false;
    this.action = "info";
    this.agroup = "element";
    this.apply = "selected";
    this.filter = "type";

    this.color = { r: 255, g: 255, b: 255, a: 1 };
    this.modelStyles = [];
    this.selectedElement = false;
    this.observableSelectedElement = false;
    this.featuredElement = false;
    this.observableFeaturedElement = false;
    this.workerCallback = false;
    this.workerResting = true;
    this.modoPanOnOff = false;
    this.esmaecerItem = false;
    this.visibilityItem = false;
    this.invisibilityItem = false;
    this.reloadViewer = true;
    this.typesNavigation = [];
    this.RenderViewActive = false;
    this.fileName = "";
    this.propertyRendered = [];
    this.loadingViewer = false;
    this.toolbarLoading = false;
    this.isolateArray = [];
    this.viewerStarted = false;
    this.navigationLoaded = false;
    this.viewerLoadCounter = 0;
    this.reverseLabelArray = new Array<number>();
    this.isReverseIsolate = false;
    this.visibilityElement3D = [];
    this.sectionPlanesPlugin = null;
    this.mathSectionPlanesPlugin = null;
    this.isSectionPlanes = false;
    this.isDistanceMeasurements = false;
    this.entitiesXrayed = [];
    this.entitiesVisible = [];
    this.metaModelIds = [];
    this.metaModel = null;

    if (this.distanceMeasurementsPlugin) {
      this.distanceMeasurementsPlugin.clear();
      this.distanceMeasurementsPlugin.control.deactivate();
      this.distanceMeasurementsPlugin = null;
    }
  }
  resetStore() {
    this.resetViewer();
    this.itemsView = new Array<object>();
    this.itemsViewSelected = new Array<IsolateArray>();
    this.itemSelectedCached = new Array();
    this.itemUnVisibilityList = new Array<IsolateArray>();
    this.itemUnVisibilityTypeList = new Array();
    this.itemEsmaecerTypeList = new Array<IsolateArray>();
  }

  @action
  setMetaModel(metaModel: any) {
    this.metaModel = metaModel;
  }

  @action
  setMetaModelId(metaModelIds: any) {
    this.metaModelIds = metaModelIds;
  }

  @action
  setFade() {
    let scene = Render3dStore.xeokitViewer.scene;
    let xrayedObjectIds = scene.xrayedObjectIds;

    for (let i = 0; i < this.itemsViewSelected.length; i++) {
      const element = this.itemsViewSelected[i];
      for (let j = 0; j < element.GUID.length; j++) {
        if (element.GUID[j].length == 1) {
          if (xrayedObjectIds.includes(element.GUID)) {
            scene.setObjectsXRayed(element.GUID, false);
          } else {
            scene.setObjectsXRayed(element.GUID, true);
          }
        } else {
          scene.setObjectsXRayed(
            element.GUID[j],
            scene.xrayedObjectIds.findIndex((i) => i == element.GUID[j]) == -1
          );
        }
      }
    }
  }

  @action
  setInvisible() {
    for (let i = 0; i < this.itemsViewSelected.length; i++) {
      const element = this.itemsViewSelected[i];
      Render3dStore.xeokitViewer.scene.setObjectsVisible(element.GUID, false);
    }
    this.entitiesVisible = this.itemsViewSelected;
  }

  @action
  setVisible() {
    for (let i = 0; i < this.itemsViewSelected.length; i++) {
      const element = this.itemsViewSelected[i];
      Render3dStore.xeokitViewer.scene.setObjectsVisible(element.GUID, true);
    }
    this.entitiesVisible = [];
  }

  @action
  setIsolateArray(newArray: IsolateArray[]) {
    this.isolateArray = newArray;
  }

  @action
  resetSectionPlane() {
    if (this.sectionPlanesPlugin != null) {
      this.sectionPlanesPlugin.hideControl(false);
      this.sectionPlanesPlugin.setOverviewVisible(false);
      this.sectionPlanesPlugin.showControl(false);
      this.sectionPlanesPlugin.getOverviewVisible(false);
      this.sectionPlanesPlugin.clear();
      this.sectionPlanesPlugin.destroy();
      this.sectionPlanesPlugin = null;
      this.mathSectionPlanesPlugin = null;
      this.isSectionPlanes = false;
    }
  }

  @action async loadXeokit(response) {
    let fileName = typeof response === "string" ? response : response.key;

    var modelId = Render3dStore.modelIdCollection.find((m: any, index) => {
      var mId = m.tag === fileName;
      return mId;
    }) as any;
    if (modelId !== undefined && modelId.tag === fileName) {
      Render3dStore.viewerLoadCounter--;
      Render3dStore.loadingViewer = Render3dStore.viewerLoadCounter > 0;
      return;
    }
    const model = WBSStore.loader(response.result, response.key);
    if (model) {
      if (this.xeokitViewer) {
        this.removeXeokitLoading();
        WBSStore.onLoadedModel(model, response.key);
      }
    }
  }

  private removeXeokitLoading() {
    if (
      this.xeokitViewer.scene != null ||
      this.xeokitViewer.scene != undefined
    ) {
      const spinner = this.xeokitViewer.scene.canvas.spinner;
      /** Torna o loading invisível */
      if (spinner && spinner.processes) spinner.processes = 0;
    }
  }

  @action getUpdatedItems() {
    var itemsList = [];
    this.libraries.map((item: any) => {
      if (item.checked) {
        const items = item.items.map(
          (itm) =>
            ({
              ...itm,
              open: false,
              hide: false,
              style: { type: "original" },
            } as never)
        );
        itemsList = itemsList.concat(items);
      }
    });
    return itemsList;
  }

  private addSelectedItems(items: IsolateArray[]) {
    let newArray = [...this.itemsViewSelected];

    items.forEach((item) => {
      let modelId = this.getModelId(item.modelId);
      let idx = newArray.findIndex((i) => i.modelId == modelId);
      if (idx == -1) {
        newArray.push({
          modelId: modelId,
          GUID: [...item.GUID],
        });
      } else {
        newArray[idx].GUID.push(...item.GUID);
      }
    });
    this.itemsViewSelected = newArray;
  }

  public cleanSelectionXeokit() {
    this.itemsViewSelected.forEach((item) => {
      this.xeokitViewer.scene.setObjectsSelected(item.GUID, false);
    });
    Render3dStore.itemsViewSelected = [];
  }

  async setSelectItemNavigatorXeokit(GUID: string, modelId: any) {
    this.cleanSelectionXeokit();
    Render3dService.getItemProps(undefined, GUID, modelId);
    Render3dStore.xeokitViewer.scene.setObjectsSelected(GUID, true);
    this.addSelectedItem([GUID], modelId);
  }

  private addSelectedItem(GUID: string[], modelId) {
    let newArray = [...this.itemsViewSelected];

    try {
      let idx = newArray.findIndex((i) => i.modelId == modelId);
      if (idx == -1) {
        newArray.push({
          modelId: modelId,
          GUID,
        });
      } else {
        newArray[idx].GUID.push(GUID[0]);
      }
    } catch (error) {}

    this.itemsViewSelected = newArray;
  }

  async setSelectedXeokit(pickResult) {
    if (!this.isDistanceMeasurements) {
      if (!pickResult.entity) {
        return;
      }

      WBSStore.rightMenuTab = ERightMenuTab.PROPERTIES;
      Render3dStore.setSelectItemNavigatorXeokit(
        pickResult.entity.id,
        pickResult.entity.model.id
      );
    }
  }

  /**
   * Retorna o modelId ao passar o elementTag quando não há o modelId, caso ele já esteja certo, apenas o retorna.
   * @method getModelId
   * @category Viewer3D
   * @param {string|number} modelId - Indentificação do modelo que o GUID pertence
   * @return {string|number} Indentificação do modelo ifc
   */
  getModelId(modelId): any {
    Render3dStore.modelIdCollection.forEach((element: any) => {
      if (element && element.tag == modelId) {
        modelId = element.model; //PRUBK-754
        return;
      }
    });
    return modelId;
  }

  setVisibilityBySelected() {
    this.itemsViewSelected.forEach((item) => {
      Render3dStore.xeokitViewer.scene.setObjectsVisible(item.GUID, true);
      this.xeokitViewer.scene.setObjectsSelected(item.GUID, true);
    });
  }

  setUnvbyType() {
    this.xRayedAllElements();
    this.setVisibilityBySelected();
  }

  /**
   * Percorre todos os objetos que estão visiveis no visualizador, e troca seu status para invisivel.
   * @method hideAllElements
   * @category Viewer3D
   * @return {void}
   */
  hideAllElements() {
    Render3dStore.xeokitViewer.scene.setObjectsVisible(
      Render3dStore.xeokitViewer.scene.visibleObjectIds,
      false
    );
  }

  /**
   * Percorre todos os objetos que estão visiveis no visualizador, e troca seu status para xray.
   * @method xRayedAllElements
   * @category Viewer3D
   * @return {void}
   */
  xRayedAllElements() {
    Render3dStore.xeokitViewer.scene.setObjectsXRayed(
      Render3dStore.xeokitViewer.scene.objectIds,
      true
    );
  }

  async isolateIfcLabelArray(ifcLabelArray) {
    await this.resetView();
    this.addSelectedItems(ifcLabelArray);
    this.setUnvbyType();
  }

  /**
   * Isola os itens no visualizador 3D
   * @method isolateElements
   * @category Viewer3D
   * @param {Array<IsolateArray>} isolateArray - Lista com todos os itens que foram selecionados para isolar
   * @param {string|number} isolateArray[].modelId - Indentificação do modelo que o GUID pertence
   * @param {Array<string>} isolateArray[].GUID - Array usado para identificar o item do 3D no viewer do xeokit
   * @param {number} [checkCount=0] - Numero de vezes que a função foi chamada, usado para garantir que o código só será chamado após terminar de carregar o viewer 3D
   * @return {void}
   */
  async isolateElements(
    isolateArray: Array<IsolateArray>,
    checkCount: number = 0
  ) {
    if (
      this.isReverseIsolate &&
      !Render3dStore.navigationLoaded &&
      checkCount < 10
    ) {
      setTimeout(
        async () => await this.isolateElements(isolateArray, checkCount++),
        500
      );
      return;
    } else {
      let isXeokitViewer =
        DevelopmentStore.developmentSelected.data.isXeokitViewer;
      await Render3dStore.resetView();
      this.xRayedAllElements();
      Render3dStore.toolbarLoading = true;
      if (this.isReverseIsolate) {
        this.reverseIsolate(isolateArray, isXeokitViewer);
      } else {
        this.isolate(isolateArray);
      }
    }
    for (let i = 0; i < this.itemsViewSelected.length; i++) {
      const element = this.itemsViewSelected[i];
      this.selectedSimilarElements.push(...element.GUID);
    }
    this.setIsolateArray([]);
    Render3dStore.toolbarLoading = false;
  }

  /**
   * Isola os itens que foram passados a função.
   * @method isolate
   * @category Viewer3D
   * @param {Array<IsolateArray>} isolateArray - Lista com todos os itens que foram selecionados para isolar
   * @param {string|number} isolateArray[].modelId - Indentificação do modelo que o GUID pertence
   * @param {Array<string>} isolateArray[].GUID - Array usado para identificar o item do 3D no viewer do xeokit
   * @param {boolean | undefined} isXeokitViewer - Se for verdadeiro o viewer é o novo (xeokit), se for falso é o viewer antigo (xbim)
   * @return {void}
   */
  private isolate(isolateArray: Array<IsolateArray>) {
    for (let j = 0; j < isolateArray.length; j++) {
      let modelId: any = Render3dStore.getModelId(isolateArray[j].modelId);

      let itemsViewSelected = [...this.itemsViewSelected];

      for (let i = 0; i < isolateArray[j].GUID.length; i++) {
        const element = isolateArray[j].GUID[i];
        itemsViewSelected = this.listOfItensToIsolate(
          modelId,
          element,
          itemsViewSelected
        );
      }
      this.itemsViewSelected = itemsViewSelected;

      for (let i = 0; i < this.itemsViewSelected.length; i++) {
        this.setIsolateState(this.itemsViewSelected[j]);
      }
    }
  }

  /**
   * Isola os itens que não foram passados a função, o projeto vai ter que percorrer todos os outros itens que não estejam na lista isolateArray.
   * @method reverseIsolate
   * @category Viewer3D
   * @param {Array<IsolateArray>} isolateArray - Lista com todos os itens que foram selecionados para isolar
   * @param {string|number} isolateArray[].modelId - Indentificação do modelo que o GUID pertence
   * @param {Array<string>} isolateArray[].GUID - Array usado para identificar o item do 3D no viewer do xeokit
   * @param {boolean | undefined} isXeokitViewer - Se for verdadeiro o viewer é o novo (xeokit), se for falso é o viewer antigo (xbim)
   * @return {void}
   */
  private async reverseIsolate(
    isolateArray: Array<IsolateArray>,
    isXeokitViewer: boolean | undefined
  ) {
    await Render3dService.fetchFileItemsIfcRef();
    let itemsViewLabels: Array<IsolateArray> = new Array<IsolateArray>();

    for (let i = 0; i < Render3dStore.itemsView.length; i++) {
      const element = Render3dStore.itemsView[i];
      itemsViewLabels = this.listOfItensToIsolate(
        element.modelId,
        element.GUID,
        itemsViewLabels
      );
    }

    let itemsViewLabelsArray: Array<IsolateArray> = new Array<IsolateArray>();

    for (let i = 0; i < itemsViewLabels.length; i++) {
      let item = itemsViewLabels[i];
      let found = false;
      for (let j = 0; j < isolateArray.length; j++) {
        let o = isolateArray[j];
        let modelId1 = Render3dStore.getModelId(item.modelId);
        let modelId2 = Render3dStore.getModelId(o.modelId);

        // Se o model id do isolateArray for undefined ou NAN significa que o model map foi criado antes da correção
        // que adicionou o ModelId as linhas do modelMap
        if (
          modelId1 == modelId2 ||
          modelId2 == undefined ||
          (isNaN(modelId2) && !isXeokitViewer)
        ) {
          found = true;

          let uniqueResultGUID: string[] = [];

          uniqueResultGUID = item.GUID.filter(
            (id1) => !o.GUID.some((id2) => id2 == id1)
          );

          itemsViewLabelsArray.push({
            modelId: modelId1,
            GUID: uniqueResultGUID,
          });
          continue;
        }
      }

      // Se não encontrou nenhum elemento coloca todos
      if (!found) {
        let modelId1 = Render3dStore.getModelId(item.modelId);
        itemsViewLabelsArray.push({
          modelId: modelId1,
          GUID: item.GUID,
        });
      }
    }
    for (let i = 0; i < itemsViewLabelsArray.length; i++) {
      let modelId = Render3dStore.getModelId(itemsViewLabelsArray[i].modelId);
      this.setIsolateState(itemsViewLabelsArray[i]);
    }
    this.itemsViewSelected = itemsViewLabelsArray;
    this.isReverseIsolate = false;
  }

  /**
   * .Função responsavel por adicionar ao array listToIsolate os GUID passados por parametro na função
   * @method listOfItensToIsolate
   * @category Viewer3D
   * @param {string|number} modelId - Indentificação do modelo que o GUID pertence
   * @param {Array<string>} GUID - Array usado para identificar o item do 3D no viewer do xeokit
   * @param {Array<object>} listToIsolate - Lista com todos os itens a serem isolados
   * @param {string|number} listToIsolate[].modelId - Indentificação do modelo que o GUID pertence
   * @param {Array<string>} listToIsolate[].GUID - Array usado para identificar o item do 3D no viewer do xeokit
   * @return {Array<string>} Lista com todos os itens a serem isolados
   */
  listOfItensToIsolate(modelId, GUID, listToIsolate) {
    let idx = listToIsolate.findIndex((j) => j.modelId == modelId);
    if (idx == -1) {
      listToIsolate.push({
        modelId: modelId,
        GUID: [GUID],
      });
    } else {
      listToIsolate[idx].GUID.push(GUID);
    }

    return listToIsolate;
  }

  /**
   * .Executa o isolar, percorrendo a lista e colocando o status dos itens como visible e selected
   * @method setIsolateState
   * @category Viewer3D
   * @param {boolean} isXeokitViewer - Verifica se projeto usa o viewer novo (xeokit) ou o antigo (xbim)
   * @param {Array<object>} listToIsolate - Lista com todos os itens a serem isolados
   * @param {Array<string>} listToIsolate[].GUID - Array usado para identificar o item do 3D no viewer do xeokit
   * @param {string|number} modelId - Indentificação do modelo que o GUID pertence
   * @return {void}
   */
  setIsolateState(listToIsolate: any) {
    try {
      const scene = this.xeokitViewer.scene;
      scene.setObjectsXRayed(listToIsolate.GUID, false);
      scene.setObjectsSelected(listToIsolate.GUID, true);
    } catch (error) {}
  }

  @action
  async selectSimilarElements() {
    await Render3dService.fetchFileItemsIfcRef();
    let others = [...this.itemsView];
    let elementType = "";

    for (let i = 0; i < this.itemsViewSelected.length; i++) {
      others.forEach((el) => {
        if (typeof el.GUID === "string" || el.GUID instanceof String) {
          el.GUID = [el.GUID];
        }
        if (
          el.GUID.findIndex((g) => g == this.itemsViewSelected[i].GUID) != -1
        ) {
          elementType = el.subType;
          return;
        }
      });
      if (elementType != "") {
        break;
      }
    }

    let othersTypes = others.filter((el) => el.subType == elementType);

    othersTypes.forEach((el) => {
      this.selectedSimilarElements.push(el.GUID);
    });
    this.itemsViewSelected = othersTypes;

    this.xeokitViewer.scene.setObjectsSelected(
      this.selectedSimilarElements,
      true
    );
  }

  @action
  async initVisibilityElement3D() {
    this.visibilityElement3D = await Render3dService.fetchVisibilityElement3D();
  }

  /** Obtém os dados de elementos habilitados e desabilitados no Navegador 3D e
   * obtém todos os elementos dos modelos ativos do projeto. Depois
   * executa a função para exibi-los no Visualizador 3D
   */
  async fetchIfcItemsAndSetVisibilityByTypes() {
    const visibilityTypes = await Render3dService.fetchVisibilityElement3D();
    await Render3dService.fetchFileItemsIfcRef();
    this.setVisibilityByTypes(visibilityTypes);
  }

  /** Verifica os elementos e obtém os correspondentes aos tipos desabilitados no
   * Navegador 3D e no final os oculta no visualizador.
   */
  @action
  private setVisibilityByTypes(visibilityTypes) {
    const ifcItems = [...this.itemsView];
    const elements: any = [];

    if (visibilityTypes != undefined) {
      for (const type of visibilityTypes) {
        ifcItems.forEach((el) => {
          if (el.type == type) elements.push(el.GUID);
        });
      }

      if (this.xeokitViewer && this.xeokitViewer.scene != null) {
        this.xeokitViewer.scene.setObjectsVisible(elements, false);
      }
    }
  }

  @action
  async setVisibilityElementsByTypeOrObjectType(
    type: string,
    visibity: boolean
  ) {
    const scene = this.xeokitViewer.scene;
    this.selectedSimilarElements = [];

    scene.setObjectsSelected(scene.selectedObjectIds, false);
    scene.setObjectsXRayed(scene.xrayedObjectIds, false);

    await Render3dService.changeVisibilityByType(type, visibity);
    await Render3dService.fetchFileItemsIfcRef();
    let others = [...this.itemsView];
    let othersTypes: any = [];
    othersTypes = others.filter((el) => el.type == type);
    othersTypes.forEach((el) => {
      this.selectedSimilarElements.push(el.GUID);
    });

    this.itemsViewSelected = othersTypes;

    if (visibity) {
      this.xeokitViewer.scene.setObjectsVisible(
        this.selectedSimilarElements,
        true
      );
    } else {
      this.xeokitViewer.scene.setObjectsVisible(
        this.selectedSimilarElements,
        false
      );
    }

    this.selectedSimilarElements = [];
  }

  @action
  async selectSimilarElementsByTypeOrObjectType(
    type?: string,
    objectType?: string
  ) {
    this.propertyRendered = [];
    this.xeokitViewer.scene.setObjectsSelected(
      this.xeokitViewer.scene.selectedObjectIds,
      false
    );
    this.unSelectSimilarElements();
    await Render3dService.fetchFileItemsIfcRef();
    let others = [...this.itemsView];
    let othersTypes: any = [];

    if (type) {
      othersTypes = others.filter((el) => el.type == type);
    }

    if (objectType) {
      othersTypes = others.filter((el) => el.subType == objectType);
    }

    othersTypes.forEach((el) => {
      this.selectedSimilarElements.push(el.GUID);
    });
    this.itemsViewSelected = othersTypes;

    othersTypes.forEach((item) => {
      this.xeokitViewer.scene.setObjectsSelected(item.GUID, true);
    });
  }

  @action
  unSelectSimilarElements() {
    this.xeokitViewer.scene.setObjectsSelected(
      this.selectedSimilarElements,
      false
    );
    this.selectedSimilarElements = [];
  }

  setIsolateItems(isolate = false) {
    if (isolate) {
      this.hideAllElements();
      this.itemsViewSelected.forEach((item) => {
        this.xeokitViewer.scene.setObjectsVisible(item.GUID, true);
        this.xeokitViewer.scene.setObjectsSelected(item.GUID, true);
      });
    } else {
      this.xRayedAllElements();
      this.itemsViewSelected.forEach((item) => {
        this.xeokitViewer.scene.setObjectsXRayed(item.GUID, false);
        this.xeokitViewer.scene.setObjectsSelected(item.GUID, true);
      });
    }
  }

  unsetIsolateItems(objectIds) {
    this.xeokitViewer.scene.setObjectsVisible(objectIds, true);
  }

  setHighLightXeokit() {
    Render3dStore.xeokitViewer.scene.setObjectsXRayed(
      Render3dStore.xeokitViewer.scene.visibleObjectIds,
      true
    );

    this.itemsViewSelected.forEach((item) => {
      this.xeokitViewer.scene.setObjectsXRayed(item.GUID, false);
    });
  }

  unsetHighLightXeokit(objectIds) {
    this.xeokitViewer.scene.setObjectsXRayed(objectIds, false);
  }

  async setHighliht() {
    //
    await Render3dService.fetchFileItemsIfcRef();

    this.setVisibilityBySelected();
  }
  async resetView(resetVisibility = true) {
    let objectIds = Render3dStore.xeokitViewer.scene.objectIds;
    this.loadingViewer = true;
    if (this.isSectionPlanes) this.resetSectionPlanes();
    this.unsetHighLightXeokit(objectIds);
    this.unsetIsolateItems(objectIds);
    this.unSelectSimilarElements();
    if (this.isDistanceMeasurements) {
      this.distanceMeasurementsPlugin.clear();
      this.distanceMeasurementsPlugin.control.deactivate();
      this.isDistanceMeasurements = false;
    }
    this.entitiesXrayed.forEach((el) => {
      if (el.xrayed == true) {
        el.xrayed = false;
      }
    });

    this.entitiesVisible.forEach((el) => {
      if (el.visible == false) {
        el.visible = true;
      }
    });

    const scene = this.xeokitViewer.scene;
    scene.setObjectsSelected(scene.selectedObjectIds, false);
    scene.setObjectsXRayed(scene.xrayedObjectIds, false);

    if (resetVisibility) Render3dStore.xeokitViewer.cameraFlight.flyTo();
    this.itemsViewSelected = new Array<IsolateArray>();
    this.itemUnVisibilityList = new Array<IsolateArray>();
    this.itemUnVisibilityTypeList = new Array();
    this.itemEsmaecerTypeList = new Array<IsolateArray>();
    await Render3dStore.fetchIfcItemsAndSetVisibilityByTypes();
    if (resetVisibility) this.resetVisibilityElement3D();
    this.loadingViewer = false;
  }

  @action async resetVisibilityElement3D() {
    await this.setTypesInvisible(this.visibilityElement3D);
  }

  async setTypesInvisible(dados) {
    await Render3dService.setTypesInvisible(dados);
  }
  async getTypesInvisible() {
    let data = await Render3dService.getTypesInvisible();
    return data;
  }

  private inputEventId = 0;

  @action
  sectionPlanes() {
    const activePlanes = !this.isSectionPlanes;
    this.isSectionPlanes = activePlanes;

    if (activePlanes) {
      if (!this.sectionPlanesPlugin) {
        this.sectionPlanesPlugin = this.createSectionPlanePlugin();
      }

      let temp: any = window;
      this.mathSectionPlanesPlugin = temp.xeokit.math;
    }

    this.toggleSectionPlane(activePlanes);
    this.xeokitViewer.scene.input.off(this.inputEventId);
    if (activePlanes) {
      this.sectionPlanesPlugin.showControl(this.sectionPlaneId);
      this.inputEventId = this.xeokitViewer.scene.input.on(
        "mouseclicked",
        (coords) => {
          this.addSectionPlane(coords);
        }
      );
    }
  }
  @action
  distanceMeasurements() {
    const activeDistanceMeasurements = !this.isDistanceMeasurements;
    this.isDistanceMeasurements = activeDistanceMeasurements;

    if (activeDistanceMeasurements) {
      if (this.distanceMeasurementsPlugin == null) {
        this.distanceMeasurementsPlugin =
          this.createDistanceMeasurementsPlugin();
      }
      this.distanceMeasurementsPlugin.control.activate();
      this.xeokitViewer.scene.input.off(this.inputEventId);
    } else {
      this.distanceMeasurementsPlugin.control.deactivate();
    }
  }

  private createSectionPlanePlugin() {
    let temp: any = window;
    return new temp.xeokit.SectionPlanesPlugin(this.xeokitViewer, {
      overviewCanvasId: "mySectionPlanesOverviewCanvas",
      overviewVisible: true,
    });
  }
  private createDistanceMeasurementsPlugin() {
    let temp: any = window;
    let div = document.getElementById("distanceMeasurementContainer");
    return new temp.xeokit.DistanceMeasurementsPlugin(this.xeokitViewer, {
      container: div,
    });
  }

  private resetSectionPlanes() {
    if (this.sectionPlanesPlugin) {
      this.toggleSectionPlane(false);
      this.sectionPlanesPlugin.clear();
      this.sectionPlanesPlugin.destroy();
      this.sectionPlanesPlugin = null;
    }
    this.isSectionPlanes = false;
  }

  private toggleSectionPlane(active: boolean) {
    if (!this.sectionPlanesPlugin) return;
    this.sectionPlanesPlugin.hideControl(active);
    this.sectionPlanesPlugin.setOverviewVisible(active);
    this.sectionPlanesPlugin.showControl(active);
    this.sectionPlanesPlugin.getOverviewVisible(active);
  }

  private addSectionPlane(coords) {
    if (!this.sectionPlanesPlugin) return;

    const qttPlanes = Object.keys(
      this.sectionPlanesPlugin.sectionPlanes
    ).length;
    if (qttPlanes >= 1) return;

    const pickResult = this.xeokitViewer.scene.pick({
      canvasPos: coords,
      pickSurface: true,
    });

    if (this.isSectionPlanes) {
      if (pickResult && pickResult.worldNormal) {
        const sectionPlane = this.sectionPlanesPlugin.createSectionPlane({
          pos: pickResult.worldPos,
          dir: this.mathSectionPlanesPlugin.mulVec3Scalar(
            pickResult.worldNormal,
            -1
          ),
        });

        this.sectionPlaneId = sectionPlane.id;
        this.sectionPlanesPlugin.showControl(this.sectionPlaneId);
      }
    }
  }

  /** PRUBK-1189 -> Correção - Cubo não muda visualização dos modelos */
  initSectionPlanes() {
    const plane = this.createSectionPlanePlugin();
    if (plane) {
      plane.setOverviewVisible(true);
      plane.setOverviewVisible(false);
    }

    this.sectionPlanesPlugin = null;
    this.sectionPlanesPlugin = plane;
  }

  async setItemsToIsolate() {
    if (Render3dStore.xeokitViewer == null) {
      Render3dStore.needIsolateArray = true;
      WBSStore.get3dModel(WBSStore.WBS.id);
      WBSStore.handle3DTabXeokit();
    } else {
      // PRUBK-423 - Utilização condicional de função para isolar elementos considerando o array tipado de labels apenas se esta informação estiver disponível.
      // Caso contrário, utiliza o método isolateIfcLabelArray considerando model maps que ainda não tiverem formatação salva e labels identificadas.
      this.xRayedAllElements();
      await Render3dStore.isolateIfcLabelArray(Render3dStore.isolateArray);
    }
  }

  countModelElements(): number {
    let count = 0;
    const dev = DevelopmentStore.developmentSelected;
    if (!dev) return count;

    for (let i = 0; i < this.itemsViewSelected.length; i++) {
      if (
        typeof this.itemsViewSelected[i].GUID === "string" ||
        this.itemsViewSelected[i].GUID instanceof String
      ) {
        count += 1;
      } else {
        count += this.itemsViewSelected[i].GUID.length;
      }
    }
    return count;
  }
}

let Render3dStore = new Store();

export { Render3dStore };



// WEBPACK FOOTER //
// ./src/modules/render3D/Render3dStore.ts